import React, { useEffect, useState } from "react";
import { P } from "@streeteasy/design-system/typography";
import { useField, useFormikContext } from "formik";
import { func } from "prop-types";

import analytics from "../../utilities/analytics";
import useContactExpert from "../../utilities/hooks/useContactExpert";
import useContactListingAgent from "../../utilities/hooks/useContactListingAgent";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import * as S from "./styled";

const MessageScreening = ({ onSubmit, switchFlow }) => {
  const { expertsApiUuid, messageScreeningFlag } = useFeatureState();
  const { setFieldError, values } = useFormikContext();
  const [, { error }] = useField("form_submission");
  const [submittingButtonType, setSubmittingButtonType] = useState("");
  const sendToListingAgent = useContactListingAgent();
  const sendToBuyerAgent = useContactExpert();

  useEffect(() => {
    analytics({
      action: "impressions_for_experts_hdp_listing_agent_redirect",
      isHdp: true,
      label: `uuid=${expertsApiUuid}|flag=${messageScreeningFlag}`
    });
  }, []);

  const executeAction = async (actionFunc, buttonType, callbackFunc) => {
    if (submittingButtonType !== "") {
      return;
    }

    setFieldError("form_submission", null);
    setSubmittingButtonType(buttonType);
    const result = await actionFunc(values);

    if (result.error) {
      setFieldError("form_submission", "Failed to deliver message");
      setSubmittingButtonType("");
    } else {
      if (callbackFunc) {
        callbackFunc();
      }

      await onSubmit();
    }
  };

  return (
    <S.FullSizeContainer data-qa="message-screening">
      <S.InfoCard>
        <P>Are you interested in renting or buying this property?</P>
      </S.InfoCard>
      <S.Button
        disabled={submittingButtonType === "redirect"}
        onClick={() =>
          executeAction(sendToListingAgent, "redirect", switchFlow)
        }
        theme="PRIMARY"
      >
        Renting
      </S.Button>
      <S.Button
        disabled={submittingButtonType === "continue"}
        onClick={() => executeAction(sendToBuyerAgent, "continue")}
        theme="SECONDARY"
      >
        Buying
      </S.Button>
      {error && <S.Error>{error}</S.Error>}
    </S.FullSizeContainer>
  );
};

MessageScreening.propTypes = {
  onSubmit: func.isRequired,
  switchFlow: func.isRequired
};

export default MessageScreening;
